import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from 'Components/layout/Button';

export default class MissionCostEstimationProgressPanel extends Component {
    static propTypes = {
        onSave: PropTypes.func.isRequired,
        isSavePending: PropTypes.bool.isRequired,
        validationError: PropTypes.bool.isRequired,
        lastSaveStatus: PropTypes.bool,
        sections: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                isVisible: PropTypes.bool,
                valueTransform: PropTypes.func.isRequired
            }).isRequired
        ).isRequired,
        state: PropTypes.object.isRequired,
        containerStyle: PropTypes.object
    };
    static defaultProps = {
        showBrandHeader: true
    };

    state = {
        saveButtonMessage: 'Send',
        confirmed: false,
        containerStyle: {}
    }

    componentWillReceiveProps = nextProps => {
        if (this.props.isSavePending !== nextProps.isSavePending && nextProps.lastSaveStatus === true) {
            this.setState(prevState => ({
                saveButtonMessage: 'Sent!',
                confirmed: true
            }));
        }
    }

    render() {

        const { saveButtonMessage, confirmed } = this.state;
        const { sections, state, onSave, isSavePending, containerStyle, validationError, showSendButton } = this.props;

        return (
            <div className="component-mission-cost-estimation-progress-panel" style={containerStyle}>
                <div className="steps">
                    {sections.map(section => (
                        <div key={section.name} className={`progress-step ${section.isVisible ? 'active' : ''}`}>
                            <span className="step-label">{section.title}: </span>
                            <span className="step-value">{section.valueTransform(state)}</span>
                        </div>
                    ))}
                </div>
                {validationError &&
                    <p className="error">
                        There are some validation errors in you data. Please correct values and submit form again.
                    </p>
                }
                {confirmed &&
                    <p className="confirm">
                        Thank you very much! Our sales team will contact you in next 24h to discuss your project.
                    </p>
                }
                { showSendButton && 
                    <div className="controls">
                        <Button
                            className="control control-save"
                            styleType="primaryInvert"
                            isLoading={isSavePending}
                            onClick={onSave}
                            disabled={confirmed}
                        >
                            {saveButtonMessage}
                        </Button>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/missionCostEstimation/ProgressPanel/index.js